import { render, staticRenderFns } from "./ClientComponent.vue?vue&type=template&id=11735bfc&scoped=true&"
import script from "./ClientComponent.vue?vue&type=script&lang=js&"
export * from "./ClientComponent.vue?vue&type=script&lang=js&"
import style0 from "./ClientComponent.vue?vue&type=style&index=0&id=11735bfc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11735bfc",
  null
  
)

export default component.exports